import React from "react";
import PersonalDataStepShared from "../common/components/PersonalDataStep/PersonalDataStepShared";
import { useDataProtectionPath } from "../common/hooks/useDataProtectionPath";

/**
 * Parcel-delivery customer-data step. Thin wrapper over the shared, prop-gated
 * {@link PersonalDataStepShared} (issue #868). Parcel collects only the base
 * fields (name / email / phone, + USC for USC partners) and links its terms to
 * the tenant's dedicated terms-of-service hint page when one exists
 * (`useDataProtectionPath` — extracted from this flow's previously inlined
 * logic). Unlike SUP / product rental it does NOT auto-agree on mount, so
 * `showAgreement` is omitted.
 */
const PersonalDataStep = () => {
  const dataProtectionPath = useDataProtectionPath();
  return <PersonalDataStepShared dataProtectionPath={dataProtectionPath} />;
};

export default PersonalDataStep;
